import React from 'react';

import { useQuery } from '@apollo/client/react';
import { MainView } from '@repo/ui/Views';
import { Authorization, POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { FallbackCard } from '@repo/ui/Card';

import DIDS_SHOW_Q from '../gql/show.gql';
import DidTabNav from '../components/DidTabNav';

import SmsForward from '../components/SmsForward';
import MmsForward from '../components/MmsForward';
import { useParams } from 'react-router';

const DidForwards = () => {
  const user = useUser();

  const params = useParams();
  const didId = params.didId;

  const { loading, data, refetch } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />
      <div className="flex flex-col gap-12">
        {data?.did?.switch?.id ? (
          <>
            <Authorization
              policyCheck={POLICIES['switches:index'](user)}
              fallbackView={
                <FallbackCard
                  title="No access"
                  description="You do not have the permissions to view message forwards."
                />
              }
            >
              <SmsForward
                didSwitch={data?.did?.switch}
                refetch={refetch}
                canUpdate={POLICIES['switches:update'](user)}
              />
              <MmsForward
                didSwitch={data?.did?.switch}
                refetch={refetch}
                canUpdate={POLICIES['switches:update'](user)}
              />
            </Authorization>
          </>
        ) : (
          <p>No DID switch found </p>
        )}
      </div>
    </MainView>
  );
};

export default DidForwards;
